/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImagePlaceholder/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import FileUploadInput from 'DesignSystem/FileUploadInput/react'
import PatientImageCard from 'DesignSystem/PatientImageCard/index'
import PatientImageExample from 'DesignSystem/PatientImageExample/index'
import Processing from './Processing/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ImagePlaceholder({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Images/ImageSlot/ImageAction/ImagePlaceholder"
  
}) {
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let imageSlotKeyValueData = fromData.useDataFormat({ viewPath,
context: 'image',
path: 'slot_key',
format: fromFormat.getPatientImageName,
})
let imageSlotKeyValueData1 = fromData.useDataValue({ viewPath,
context: 'image',
path: 'slot_key',
})
let settingsIntraoralMobileCaptureExamplesEnabledValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'intraoral_mobile_capture_examples_enabled',
})
let imagesRequestParentCompanyUuidValueData = fromData.useDataValue({ viewPath,
context: 'images_request',
path: 'parent_company_uuid',
})
let imageSlotKeyValueData2 = fromData.useDataFormat({ viewPath,
context: 'image',
path: 'slot_key',
format: fromFormat.getPatientImageName,
})
let imageSlotKeyValueData3 = fromData.useDataValue({ viewPath,
context: 'image',
path: 'slot_key',
})
  return (<React.Fragment
>
<div
  data-testid="ImagePlaceholder.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<FileUploadInput
  viewPath={`${viewPath}/FileUploadInput`}
 accept="image/jpeg"
 capture="environment"
 onChange={onChange}
>
{childProps => (
<PatientImageCard
{...childProps}
  viewPath={`${viewPath}/PatientImageCard`}
 data="image.slot_key"
 format="/Data/format.js getPatientImageName"
 label={imageSlotKeyValueData}
 data="image.slot_key"
 slot_key={imageSlotKeyValueData1}
/>
)}
</FileUploadInput>
<PatientImageExample
  viewPath={`${viewPath}/PatientImageExample`}
 data="settings.intraoral_mobile_capture_examples_enabled"
 show_example={settingsIntraoralMobileCaptureExamplesEnabledValueData}
 data="images_request.parent_company_uuid"
 organization_id={imagesRequestParentCompanyUuidValueData}
 data="image.slot_key"
 format="/Data/format.js getPatientImageName"
 label={imageSlotKeyValueData2}
 data="image.slot_key"
 slot_key={imageSlotKeyValueData3}
/>
</div>
<Processing
  viewPath={`${viewPath}/Processing`}
/>
{children}
</React.Fragment>)
}